var FunctionUtils;
((FunctionUtils2) => {
  FunctionUtils2.getParameterNames = (func, property) => {
    if (typeof func === "object" && property) {
      func = func[property];
    }
    return new RegExp("(?:" + func.name + "\\s*|^)\\s*\\((.*?)\\)").exec(func.toString().replace(/\n/g, ""))?.[1].replace(/\/\*.*?\*\//g, "").replace(/ /g, "").split(",") ?? [];
  };
  FunctionUtils2.evalScript = (script, obj) => {
    try {
      if (script && obj) {
        return Function(`"use strict";
                    ${script}
                    `).bind(obj)();
      } else if (script) {
        return new Function("return " + script)();
      } else {
        return null;
      }
    } catch (e) {
      return null;
    }
  };
  FunctionUtils2.execute = (params) => {
    const { script, context, args = {} } = params;
    const argNames = Object.keys(args);
    const argValues = Object.values(args);
    return new Function(...argNames, script).apply(context, argValues);
  };
  FunctionUtils2.executeReturn = (params) => {
    const { script, context, args = {} } = params;
    const argNames = Object.keys(args);
    const argValues = Object.values(args);
    return new Function(...argNames, `return ${script}`).apply(context, argValues);
  };
})(FunctionUtils || (FunctionUtils = {}));
export {
  FunctionUtils
};
//# sourceMappingURL=FunctionUtils.js.map
